import { AppForm } from '../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CustomValidator } from '../../../../../../common/forms/custom.validators';

@Injectable()
export class LocationDecisionItemForm extends AppForm {
  constructor() {
    super({
      decisionNumber: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      decisionDate: new FormControl(null, [Validators.required, CustomValidator.isValidDateFormat(), CustomValidator.maxDate(new Date())])
    });
  }
}
